export default ({ xAxisGridLineWidth = 1 }) => ({
  xAxis: {
    gridLineWidth: xAxisGridLineWidth,
  },
});
